import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/DiversityPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = insights_helper.fetch({
    limit: 3,
    filter: (i) => ("tags" in i ? i?.tags?.includes("DEI") : false),
    map: (i) => ({ ...i, tags: ["DEI"] }), // we only want to display the DEI tag to the user
  });

  const routerProp = router["about.diversity"];
  const titleKey = "page.diversity.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "DiversityPageBannerSection" },
        { component: "DiversityPageContentSection" },
        { component: "DiversityPageOfferingsSection" },
        { component: "CommitteeSection" },
        {
          component: "InsightsSection",
          props: { items: insights, title: { path: "page.dei.insights.title.en" }, sidebar: false },
        },
        { component: "AwardsSection", props: { className: "py-4 py-md-5" } },
      ],
    },
  };
}
